const Health = () => 'success';

export default Health;
